import type { PatientName } from '@/domain/case/personName';

export interface DicomPatientName {
    familyName?: string;
    givenName?: string;
    middleName?: string;
    prefix?: string;
    suffix?: string;
}

export type DicomPatientSex = 'male' | 'female' | 'other';

export enum DicomPatientSexValues {
    Other = 'O',
    Female = 'F',
    Male = 'M',
}

export type DicomPatientSexValuesType =
    | DicomPatientSexValues.Male
    | DicomPatientSexValues.Female
    | DicomPatientSexValues.Other
    | undefined;

export interface PatientPersonalInfo {
    name?: PatientName;
    sex?: DicomPatientSex;
    birth_date?: string; // see PATIENT_DATE_OF_BIRTH_FORMAT
}

export const PATIENT_DATE_OF_BIRTH_FORMAT = 'yyyy-MM-dd';

export enum BooleanFieldValues {
    Yes = 'YES',
    No = 'NO',
}
